import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IAttachmentType } from "../model/AttachmentType";
import AttachmentTypeMapper from "../service/AttachmentTypeMapper";
import AttachmentTypeParamMapper from "../service/AttachmentTypeParamMapper";

export default class GetAllGenericAttachmentTypesInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachmentType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.attachmentTypePath,
      AttachmentTypeMapper,
      AttachmentTypeParamMapper
    );
  }
}
